<div class="tab-container">
    <div class="card">
        <ng-container *ngFor="let sensor of model.otherSensors, let i = index">
            <div class="sensor-row">
                <div class="input-group">
                    <label class="flex-center">{{ i + 1 | number:'2.0-0' }}</label>
                    <div class="icon-button">
                        <i class="juc ju-delete" (click)="onRemoveBtnClicked(i)"></i>
                    </div>
                </div>

                <div class="input-group col1">
                    <label [for]="'moduleId' +i">Module ID*</label>
                    <select [name]="'moduleId'+i"
                            [id]="'moduleId'+i"
                            required
                            #dynamicInput="ngModel"
                            [ngClass]="{'no-value': sensor.uvsModuleId === undefined}"
                            [(ngModel)]="sensor.uvsModuleId"
                            (ngModelChange)="updateSensorId($event, i)">
                        <option [ngValue]="undefined" disabled>Bitte auswählen</option>
                        <ng-container *ngFor="let option of moduleIds">
                            <option [ngValue]="option">{{ option }}</option>
                        </ng-container>
                    </select>
                </div>

                <div class="input-group col2">
                    <label [for]="'sensorType'+i">Sensor*</label>
                    <select [name]="'sensorType'+i"
                            [id]="'sensorType'+i"
                            required
                            [ngClass]="{'no-value': sensor.sensorType === undefined}"
                            [(ngModel)]="sensor.sensorType"
                            [disabled]="sensor.uvsModuleId === undefined"
                            (ngModelChange)="updateSensorType($event, i)"
                            #dynamicInput="ngModel">
                        <option [ngValue]="undefined" disabled>Bitte auswählen</option>
                        <ng-container
                                *ngFor="let option of getSensorTypesStillAvailableForModule(sensor.uvsModuleId, i)">
                            <option [ngValue]="option.value">
                                {{ option.label }}
                            </option>
                        </ng-container>
                    </select>
                </div>

                <div class="align-to-end">
                    <app-input-image-upload
                            [id]="'sensorPhoto' + i"
                            [name]="'sensorPhoto' + i"
                            required
                            [imageQuality]="LOW_IMAGE_QUALITY"
                            label="Sensor"
                            [(ngModel)]="sensor.image"
                            #dynamicInput="ngModel">
                    </app-input-image-upload>
                </div>

            </div>
            <div class="sensor-row" *ngIf="isSensorAShaftContact(sensor)">
                <app-input-on-off
                        [(ngModel)]="sensor.sensorOn"
                        [name]="'shaftContact' + i">
                    <span class="on">Offen</span>
                    <span class="off">Geschlossen</span>
                </app-input-on-off>

            </div>
        </ng-container>

        <div class="button-container">
            <button class="secondary" type="button" (click)="addOtherSensor()"
                    [disabled]="model?.otherSensors?.length >= getMaxOtherSensorCount()">
                <i class="ju ju-add"></i>
                Sensor hinzufügen
            </button>
        </div>
    </div>

    <div class="card">
        <ng-container *ngFor="let sensor of model.pressureSensors, let i = index">
            <div class="pressure-sensor-row">
                <div class="input-group">
                    <label class="flex-center">{{ i + 1 | number:'2.0-0' }}</label>
                    <div class="icon-button">
                        <i class="juc ju-delete" (click)="onRemovePressureBtnClicked(i)"></i>
                    </div>
                </div>

                <div class="input-group col1">
                    <label [for]="'sensorId' +i">Sensor ID*</label>
                    <select [name]="'sensorId'+i"
                            [id]="'sensorId'+i"
                            required
                            #dynamicInput="ngModel"
                            [ngClass]="{'no-value': sensor.sensorId === undefined}"
                            [(ngModel)]="sensor.sensorId"
                            (ngModelChange)="updatePressureSensorId($event, i)">
                        <option [ngValue]="undefined" disabled>Bitte auswählen</option>
                        <ng-container *ngFor="let option of getPressureSensorIdOptions(i)">
                            <option [ngValue]="option.value">{{ option.value }}</option>
                        </ng-container>
                    </select>
                </div>

                <div class="align-to-end">
                    <app-input-image-upload
                            [id]="'pressureSensorPhoto' + i"
                            [name]="'pressureSensorPhoto' + i"
                            required
                            [imageQuality]="LOW_IMAGE_QUALITY"
                            label="Sensor"
                            [(ngModel)]="sensor.image"
                            #dynamicInput="ngModel">
                    </app-input-image-upload>
                </div>
            </div>

            <div class="pressure-limits-row">
                <div class="input-group col2">
                    <label [for]="'lowerLimit' + i">Untergrenze*</label>
                    <div class="unit-bar">
                        <input [name]="'lowerLimit' + i"
                               [id]="'lowerLimit' + i"
                               type="number"
                               required
                               [appMaxNumber]="sensor.upperLimit"
                               #lowerLimitModel="ngModel"
                               [(ngModel)]="sensor.lowerLimit"
                               (ngModelChange)="updateValidity(upperLimitModel)"/>
                    </div>
                    <div class="error">
                        <span *ngIf="showError(lowerLimitModel)">Pflichtfeld!</span>
                    </div>
                </div>
                <div class="input-group col2">
                    <label [for]="'upperLimit' + i">Obergrenze*</label>
                    <div class="unit-bar">
                        <input [name]="'upperLimit' + i"
                               [id]="'upperLimit' + i"
                               type="number"
                               required
                               [appMinNumber]="sensor.lowerLimit"
                               #upperLimitModel="ngModel"
                               [(ngModel)]="sensor.upperLimit"
                               (ngModelChange)="updateValidity(lowerLimitModel)"/>
                    </div>
                    <div class="error">
                        <span *ngIf="showError(upperLimitModel)">Pflichtfeld!</span>
                    </div>
                </div>
            </div>
        </ng-container>

        <div class="button-container">
            <button class="secondary" type="button" (click)="addPressureSensor()"
                    [disabled]="!isSomeSensorIdAvailableForPressureSensor()">
                <i class="ju ju-add"></i>
                Drucksensor hinzufügen
            </button>
        </div>
    </div>
    <div class="card">
        <ng-container *ngFor="let sensor of model.pfcSensors, let i = index">
            <div class="pfc-sensor-row">
                <div class="input-group">
                    <label class="flex-center">{{ i + 1 | number:'2.0-0' }}</label>
                    <div class="icon-button">
                        <i class="juc ju-delete" (click)="onRemovePfcBtnClicked(i)"></i>
                    </div>
                </div>

                <div class="input-group col1">
                    <label [for]="'pfc_sensorId' +i">Sensor ID*</label>
                    <select [name]="'pfc_sensorId'+i"
                            [id]="'pfc_sensorId'+i"
                            required
                            #dynamicInput="ngModel"
                            [ngClass]="{'no-value': sensor.sensorId === undefined || sensor.sensorId === null}"
                            [(ngModel)]="sensor.sensorId"
                            (ngModelChange)="updatePfcSensorId($event, i)">
                        <option [ngValue]="undefined">-</option>
                        <ng-container *ngFor="let option of getFilteredSensorIds(i)">
                            <option [ngValue]="option.value">{{ option.label }}</option>
                        </ng-container>
                    </select>
                </div>

                <div class="input-group col2">
                    <label>Sensor</label>
                    <div class="pfc-sensor-name">{{ getPfcSensorName(i) }}</div>
                </div>

                <div class="align-to-end">
                    <app-input-image-upload
                            [id]="'pfcSensorPhoto' + i"
                            [name]="'pfcSensorPhoto' + i"
                            required
                            [imageQuality]="LOW_IMAGE_QUALITY"
                            label="Sensor"
                            [(ngModel)]="sensor.image"
                            #dynamicInput="ngModel">
                    </app-input-image-upload>
                </div>
            </div>

            <div class="sensor-row">
                <app-input-on-off
                        [(ngModel)]="sensor.closed"
                        [name]="'pfcOpened' + i">
                    <span class="on">Schließer</span>
                    <span class="off">Öffener</span>
                </app-input-on-off>
            </div>

            <div class="input-group">
                <label [for]="'customName'+i">Benutzerdefinierter Name</label>
                <input type="text"
                       [name]="'customName'+i"
                       [id]="'customName'+i"
                       [(ngModel)]="sensor.customName">
            </div>
        </ng-container>

        <div class="button-container">
            <button class="secondary" type="button" (click)="addPfcSensor()"
                    [disabled]="model?.pfcSensors?.length >= moduleIds?.length * 4">
                <i class="ju ju-add"></i>
                PFC-Sensor hinzufügen
            </button>
        </div>
    </div>
</div>
<div class="field">Pflichtfelder*</div>
<app-navigation-footer
        [isBackLinkDisabled]="false"
        [backLink]="'/gateway/sensors/control'"
        [isNextLinkDisabled]="!validationService.isSensorsOtherValid(model)"
        [nextLink]="'/gateway/photos'"
        [isLast]="false"
></app-navigation-footer>
